import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MHSlider, {
  MHSliderItem,
} from "../Common/SliderCarousel/Slider/MHSlider";
// import ContentCard from "../UI/ContentCard";
import { CardMedia } from "@mui/material";

// const CONTENT = [
//   {
//     imageSrc:
//       'https://res.cloudinary.com/mother-honestly/image/upload/v1676441391/Image_16_jwcjag.png',
//     title: 'Care Wallet & Fund',
//     description:
//       'It’s easy to show employees you care by helping them catch unexpected care-related expenses, and provide emergency relief when they need it.'
//   },
//   {
//     imageSrc:
//       'https://res.cloudinary.com/mother-honestly/image/upload/v1676441388/Image_17_o5vpwr.png',
//     title: '1:1 Work & Care Guidance',
//     description:
//       'Access on-demand support and advice for diverse life, personal, and caregiving challenges from top national work-life experts.'
//   },
//   {
//     imageSrc:
//       'https://res.cloudinary.com/mother-honestly/image/upload/v1665674645/Image_4_zzfq8h.png',
//     title: 'Close The Care Gap',
//     description:
//       'When employees take leave for family care, their work remains, our Care Gap Consultants provide interim support to cover parental leave absences.'
//   }
// ];

const CONTENT = [
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/tech-caf.png",
    title: "Tech & Innovation",
    description:
      "Through initiatives like Caring Blocks, we are exploring how technology can support care delivery, connect communities, and build more efficient and inclusive care systems     ",
    path: "/care",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/economy-caf.png",
    title: "Care Economy",
    description:
      "Aggregating the care ecosystem including childcare, aging care, disability and long-term care, employee care, paid leave, and care workers to finally work for families across Africa.      ",
    path: "/care",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/policy-caf.png",
    title: "Policy & Government",
    description:
      "Advocating for caring policies in workplaces, local and national forums that advance paid family leave, universal childcare, maternal health, and the rights of care workers.",
    path: "/advisors",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/culture-caf.png",
    title: "Culture & Society",
    description:
      "Building creative campaigns, data-driven insights, and thought-leadership that changes the way we value care at home, in our workplaces, and in the society.",
    path: "/leave-gap",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/tech-caf.png",
    title: "Tech & Innovation",
    description:
      "Through initiatives like Caring Blocks, we are exploring how technology can support care delivery, connect communities, and build more efficient and inclusive care systems     ",
    path: "/care",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/economy-caf.png",
    title: "Care Economy",
    description:
      "Aggregating the care ecosystem including childcare, aging care, disability and long-term care, employee care, paid leave, and care workers to finally work for families across Africa.      ",
    path: "/care",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/policy-caf.png",
    title: "Policy & Government",
    description:
      "Advocating for caring policies in workplaces, local and national forums that advance paid family leave, universal childcare, maternal health, and the rights of care workers.",
    path: "/advisors",
  },
  {
    imageSrc:
      "https://mh-resources-production.s3.us-west-1.amazonaws.com/culture-caf.png",
    title: "Culture & Society",
    description:
      "Building creative campaigns, data-driven insights, and thought-leadership that changes the way we value care at home, in our workplaces, and in the society.",
    path: "/leave-gap",
  },
];

const HeroSlider = () => {
  return (
    <div className="overflow-hidden">
      <Box width={{ xs: "90%", sm: "90%" }} mx="auto" mt={10}>
        <Typography
          variant="h1"
          fontSize={{ xs: "30px", sm: "40px", md: "50px" }}
          textTransform="capitalize"
          align="center"
          sx={{
            mb: 4,
          }}
          paragraph
        >
          Our Bold Plan For Care In Africa
        </Typography>
        <Typography
          variant="subtitle1"
          color="primary.main"
          width={{ xs: "100%", md: "70%" }}
          fontSize={{ sm: "14px", md: "16px" }}
          lineHeight={"150%"}
          letterSpacing={"0.02em"}
          align="center"
          mx="auto"
          paragraph
        >
          We focus on creating systemic change in three critical arenas:{" "}
        </Typography>
      </Box>
      <Box py="3rem" px={{ xs: 4, md: "4rem" }}>
        <MHSlider
          autoplay={true}
          autoplaySpeed={2000}
          slidesToShow={3}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: 1024, // tablet and below
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 600, // mobile and below
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ]}
        >
          {CONTENT.map((item, index) => (
            <MHSliderItem width="100%" key={index}>
              <Box
                width="100%"
                sx={{
                  placeContent: "center",
                }}
              >
                <Box
                  height={{ xs: 370, md: 400 }}
                  overflow="hidden"
                  sx={{
                    "& > img": {
                      objectFit: "cover",
                      objectPosition: "center",
                      height: "100%",
                      width: "auto",
                      borderRadius: 4,
                    },
                  }}
                >
                  <CardMedia
                    // height="150"
                    // image="https://res.cloudinary.com/mother-honestly/image/upload/v1657976885/linkedin-sales-solutions-pAtA8xe_iVM-unsplash_kzskcn.png"
                    component="img"
                    image={item.imageSrc}
                    alt="care-solutions"
                  />
                </Box>

                <Box
                  sx={{
                    mt: 2,
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    color="primary.main"
                    align="left"
                    fontSize="20px"
                    lineHeight="140%"
                    mb={2}
                    gutterBottom
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    color="primary.main"
                    align="left"
                    fontSize="14px"
                    lineHeight="180%"
                    letterSpacing="0.04em"
                  >
                    {item.description}
                  </Typography>
                </Box>
              </Box>
              {/* <ContentCard
                imageSrc={item.imageSrc}
                title={item.title}
                description={item.description}
                onMouseClick={() => {
                  // history.push(item.path);
                  console.log(item.path);
                }}
                cardContainerSx={{
                  height: { xs: 580, md: 500, lg: 500 },
                }}
                cardContentSx={{
                  height: { xs: 220, md: 220, lg: 220 },
                }}
              /> */}
            </MHSliderItem>
          ))}
        </MHSlider>
      </Box>
    </div>
  );
};

export default HeroSlider;
